<template>
  <div class="position-relative" v-window-click="hideOptions">
    <div class="box hvh-flex align-center space-between no-wrap" :class="{ opened: showOptions, selected: selectedText }">
      <span class="clickable fit-screen" @click="openOptions">{{ selectedText || title }}</span>
      <div :class="{ 'no-show w-0': selectedText }">
        <v-icon @click="openOptions" v-if="!showOptions">mdi-menu-down</v-icon>
        <v-icon @click="showOptions = false" v-else>mdi-menu-up</v-icon>
      </div>
      <v-icon class="ml-2" color="#666adf" small @click="$emit('clear')" v-if="selectedText">mdi-close</v-icon>
    </div>
    <template v-if="showOptions">
      <div class="options" :style="optionsPositionStyle" @click.stop.prevent v-if="showOptions" ref="options">
        <slot />
      </div>
      <div class="mask"></div>
    </template>
  </div>
</template>

<script>
import { propToBool } from '../../../../libraries/common';
export default {
  props: ['title', 'right', 'middle', 'auto', 'options', 'selectedText'],
  data() {
    return {
      optionsWidth: 0,
      clientLeft: 0,
      showOptions: false,
    };
  },
  computed: {
    optionsPositionStyle() {
      if (this.showOptions) {
        var clientLeft = this.clientLeft; // Do not remove this, it is needed for recalculation
        if (propToBool(this.right))
          return { right: 0, minWidth: `${this.optionsWidth}px` };
        else if (propToBool(this.middle))
          return { left: `${-(this.optionsWidth - this.$el.offsetWidth) / 2}px`, minWidth: `${this.optionsWidth}px` };
        else if (propToBool(this.auto)) {
          var right = clientLeft + this.optionsWidth;
          if (right + 20 >= this.$store.state.windowWidth)
            return { right: 0, minWidth: `${this.optionsWidth}px` };
        }

        return { left: 0, minWidth: `${this.optionsWidth}px` };
      }
      return {};
    },
    optionsWidthTrigger() {
      return [this.showOptions, ...(this.options || [])];
    },
  },
  methods: {
    calculateOptionsWidth() {
      this.$nextTick(() => {
        if (this.$refs.options) {
          var optionsWidth = [this.optionsWidth, this.$refs.options.offsetWidth, 200].max();
          if (this.optionsWidth !== optionsWidth) {
            this.optionsWidth = optionsWidth;
          }

          var clientLeft = this.$el.getBoundingClientRect().left;
          if (this.clientLeft !== clientLeft) {
            this.clientLeft = clientLeft;
          }
        }
      });
    },
    openOptions() {
      setTimeout(() => this.showOptions = true, 50);
    },
    hideOptions() {
      this.showOptions = false;
    },
  },
  watch: {
    optionsWidthTrigger() {
      this.calculateOptionsWidth();
    },
  },
  updated() {
    this.calculateOptionsWidth();
  },
}
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  padding: 5px 16px;
  border-radius: 4px;
  background-color: #f4f5f8;

  &:not(.opened) {
    box-shadow: 0 1px 2px 1px rgba(6, 10, 36, 0.1);
  }

  &.opened {
    background-color: white;
    box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  }

  &.selected {
    color: #666adf;
    border: 0.5px solid #666adf;
    background-color: #ebecff;
    box-shadow: 0 1px 2px 1px rgba(6, 10, 36, 0.1);
  }
}
.options {
  position: absolute;
  background-color: white;
  padding: 20px 16px 4px;
  top: 34px;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  z-index: 1;
}
.mask {
  position: absolute;
  background-color: white;
  width: 100%;
  left: 0;
  top: 28px;
  height: 10px;
  z-index: 1;
}
.fit-screen {
  max-width: 400px;
  overflow: hidden;
}
</style>